import { render, staticRenderFns } from "./ClientComments.vue?vue&type=template&id=3d272b46"
import script from "./ClientComments.vue?vue&type=script&lang=js"
export * from "./ClientComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports